import { getActiveElement as c, contains as f } from "../dom/index.js";
import { focus as i } from "../focus/index.js";
import { isTabbable as l } from "../tabbable/index.js";
import { useChangeEffect as m } from "./useChangeEffect.js";
const a = (t) => {
  const e = t.current;
  if (!e) return !1;
  const r = c(e);
  return !r || f(e, r) ? !1 : !!l(r);
}, h = (t, e) => {
  const { shouldFocus: r, visible: u, focusRef: n } = e, o = r && !u;
  m(() => {
    if (!o || a(t))
      return;
    const s = n?.current || t.current;
    s && i(s, { nextTick: !0 });
  }, [o]);
};
export {
  h as useFocusOnHide
};
//# sourceMappingURL=useFocusOnHide.js.map
